import React from 'react';

const Header = ({ logoUrl }) => (
  <div className="walkthrough-header">
    <a className="logo" href="/">
      <img src={logoUrl} alt="Statuspage logo" />
      <span className="bep">Better Error Pages</span>
    </a>
    <span className="powered-by">
      <a
        href="http://statuspage.io/powered-by"
        target="_blank"
        rel="noopener noreferrer nofollow"
      >
        Powered by Statuspage
      </a>
    </span>
  </div>
);

export default Header;
